export default {
  AZURE: "azure",
  IMAP: "imap",
};
